import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAC_FindOutAwardById = createAsyncThunk(
  "AC_findOutAward/GetAC_FindOutAwardById",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_findOutAward/GetAC_FindOutAwardById",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAC_findOutAward = createAsyncThunk(
  "AC_findOutAward/UpdateAC_findOutAward",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_findOutAward/UpdateAC_findOutAward",
        {
          aC_findOutAwardId: model.aC_findOutAwardId,
          aC_findOutAwardNamesId: model.aC_findOutAwardNamesId,
          aI_ApplicationInformationId: model.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const FindOutAward = createSlice({
  name: "FindOutAward",
  initialState: {
    FindOutAward: {},
    loadingFindOutAward: false,
    errorFindOutAward: null,
    //------------------update----------------------
    FindOutAwardUpdate: [],
    loadingFindOutAwardUpdate: false,
    errorFindOutAwardUpdate: null,
  },
  reducers: {
    SetFindOutAward: (state, action) => {
      state.FindOutAward = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAC_FindOutAwardById.pending, (state, action) => {
        state.loadingFindOutAward = true;
        state.FindOutAward = action.payload;
        state.errorFindOutAward = null;
      })
      .addCase(GetAC_FindOutAwardById.fulfilled, (state, action) => {
        state.loadingFindOutAward = false;
        state.FindOutAward = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAC_FindOutAwardById.rejected, (state, action) => {
        state.loadingFindOutAward = false;
        state.errorFindOutAward = action.payload;
      })
      //------------------------update------------------------------------

      .addCase(UpdateAC_findOutAward.pending, (state, action) => {
        state.loadingFindOutAwardUpdate = true;
        state.FindOutAwardUpdate = action.payload;
        state.errorFindOutAwardUpdate = null;
      })
      .addCase(UpdateAC_findOutAward.fulfilled, (state, action) => {
        state.loadingFindOutAwardUpdate = false;
        state.FindOutAwardUpdate = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAC_findOutAward.rejected, (state, action) => {
        state.loadingFindOutAwardUpdate = false;
        state.errorFindOutAwardUpdate = action.payload;
      });
  },
});
export const { SetFindOutAward } = FindOutAward.actions;

export default FindOutAward.reducer;
